import { Component, Inject, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-refresh-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogContent, MatIcon],
  templateUrl: './refresh-dialog.component.html',
  styleUrl: './refresh-dialog.component.scss'
})
export class RefreshDialogComponent implements OnInit{
  totalFiles: any;
 readonly dialogRef = inject(MatDialogRef<RefreshDialogComponent>);
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  ) {
   }
   ngOnInit() {
     this.totalFiles = this.data;
   }
}
